import React from "react";
import Card from "../../components/page/Card.jsx";
import useApi from "../../hooks/useApi.js";
import ClienteApiClient from "../../api/cliente.js";
import EmpresaApiClient from "../../api/empresa.js";
import NotaFiscalApiClient from "../../api/notaFiscal.js";
import LocalidadeApiClient from "../../api/localidade.js";
import { AppContext } from "../../contexts/AppContext.jsx";
import ClienteTab from "./EmissorNFSe/ClienteTab.jsx";
import ServicoTab from "./EmissorNFSe/ServicoTab.jsx";
import TributacaoTab from "./EmissorNFSe/TributacaoTab.jsx";
import DadosNFSe from "./EmissorNFSe/DadosNFSe.jsx";
import AlterarMunicipioModal from "./EmissorNFSe/AlterarMunicipioModal.jsx";
import CommonSwal from "../../components/Swal/commonSwal.jsx";
import ErrorSwal from "../../components/Swal/errorSwal.jsx";
import OptionsSwal from "../../components/Swal/optionsSwal.jsx";
import TabList from "../../components/Tab/TabList.jsx";
import TabButton from "../../components/Tab/TabButton.jsx";
import TabContent from "../../components/Tab/TabContent.jsx";
import { useLocation } from "react-router-dom";
import Validation from "../../helpers/Validation.js";
import NovoClienteModal from "./EmissorNFSe/NovoClienteModal.jsx";
import { Cores } from "../../constants/Cores.js";

function EmissorNFSe() {
  const [values, setValues] = React.useState({
    itemServico: "",
    atividadeMunicipio: "",
    tipoTomador: "",
    issRetido: false,
    inssRetido: false,
    deducoes: false,
    cliente: "",
    descricaoServicoPrestado: "",
    valorTotal: 0,
    aliquota: 0,
    inss: 0,
    iss: 0,
    cofins: 0,
    irrf: 0,
    pis: 0,
    csll: 0,
    optanteSimples: false,
  });
  const [dadosNota, setDadosNota] = React.useState({});
  const [estados, setEstados] = React.useState({});
  const [servicos, setServicos] = React.useState({});
  const [atividades, setAtividades] = React.useState({});
  const [tributacaoConfig, setTributacaoConfig] = React.useState({});
  const [municipios, setMunicipios] = React.useState({});
  const [clientes, setClientes] = React.useState([]);
  const [alterarMunicipioValues, setAlterarMunicipioValues] = React.useState({
    estado: "",
    estadoId: "",
    estadoSigla: "",
    municipio: "",
    municipioId: "",
  });
  const [alterarMunicipioModal, setAlterarMunicipioModal] =
    React.useState(false);
  const [novoClienteModal, setNovoClienteModal] = React.useState(false);
  const [clienteValues, setClienteValues] = React.useState({});
  const [clienteTab, setClienteTab] = React.useState(0);
  const [tabAtual, setTabAtual] = React.useState(0);
  const [bloqueado, setBloqueado] = React.useState(false);
  const [lucroSimples, setLucroSimples] = React.useState(false);
  const [stop, setStop] = React.useState(0);
  const [exterior, setExterior] = React.useState(1);
  const { session, baseUrl } = React.useContext(AppContext);
  const [sent, setSent] = React.useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const uid = queryParams.get("uid");

  const getClienteCb = React.useCallback(() => {
    return ClienteApiClient.getCliente(
      session.empresa.replace(/E/gi, ""),
      values.cliente
    );
  }, [session.empresa, values.cliente]);

  const getMunicipiosCb = React.useCallback(() => {
    return LocalidadeApiClient.listMunicipios(alterarMunicipioValues.estadoId);
  }, [alterarMunicipioValues.estadoId]);

  const { request: getClientes, data: clientesResponse } = useApi(
    ClienteApiClient.listClientes
  );
  const { request: getCliente, data: clienteResponse } = useApi(getClienteCb);
  const { request: getMunicipios, data: municipiosResponse } =
    useApi(getMunicipiosCb);
  const { request: getEndereco } = useApi(EmpresaApiClient.getEndereco);
  const { request: getEstados } = useApi(LocalidadeApiClient.listEstados);
  const { request: getTributacaoConfig } = useApi(
    EmpresaApiClient.getTributacaoConfig
  );
  const { request: getDadosNota } = useApi(NotaFiscalApiClient.getDadosNota);
  const { request: emitirNotaFiscal } = useApi(NotaFiscalApiClient.emitirNota);
  const { request: getBloqueio } = useApi(NotaFiscalApiClient.getBloqueio);
  const { request: getCodigosMunicipio, data: codigosMunicipioResponse } =
    useApi(NotaFiscalApiClient.getCodigosMunicipio);

  //Busca clientes ao renderizar tela
  React.useEffect(() => {
    if (session.empresa && Object.keys(tributacaoConfig).length !== 0)
      getClientes(session.empresa.replace(/E/gi, ""));
  }, [getClientes, session.empresa, tributacaoConfig]);

  //Define estado clientes ao receber clientes
  React.useEffect(() => {
    if (clientesResponse) {
      const novosClientes = clientesResponse.filter(
        (cliente) => !clientes.some((c) => c.uid === cliente.uid)
      );

      setClientes((prevClientes) => [...prevClientes, ...novosClientes]);
    }
  }, [clientes, clientesResponse, tributacaoConfig.emissorExterior]);

  //Define cliente nos dados da nota ao receber cliente
  React.useEffect(() => {
    if (!clienteResponse || values.cliente === "GLOBAL") return;
    setDadosNota((prevDadosNota) => ({ ...prevDadosNota, ...clienteResponse }));
  }, [clienteResponse, clientes, setDadosNota, values.cliente]);

  //Define cliente nos dados da nota ao receber cliente
  React.useEffect(() => {
    if (!clienteResponse || values.cliente === "GLOBAL") return;
    setClientes((prevClientes) =>
      prevClientes.filter((cliente) => cliente.uid !== "GLOBAL")
    );
  }, [clienteResponse, values.cliente]);

  //Busca cliente ao alterar valor do campo
  React.useEffect(() => {
    if (values.cliente && session.empresa && values.cliente !== "GLOBAL")
      getCliente();
  }, [getCliente, session.empresa, values.cliente]);

  //Altera valores da nota quando são alterados valores de campos
  React.useEffect(() => {
    const itemServico = values?.itemServico;
    const atividadeMunicipio = values?.atividadeMunicipio;

    setDadosNota((prevData) => ({
      ...prevData,
      descricaoServicoPrestado: values?.descricaoServicoPrestado,
      itemServico,
      atividadeMunicipio,
    }));
  }, [getCliente, setDadosNota, values]);

  //Define estado municipios ao receber municipios
  React.useEffect(() => {
    if (!municipiosResponse) return;
    setMunicipios(() => ({ ...municipiosResponse }));
  }, [municipiosResponse, setMunicipios]);

  //Busca municipios ao alterar valor do campo estado
  React.useEffect(() => {
    if (!alterarMunicipioValues.estado) return;
    getMunicipios();
  }, [getMunicipios, alterarMunicipioValues.estado]);

  //Busca endereço da empresa atual e popula dados da nota
  React.useEffect(() => {
    const atualizarConfiguracoes = async () => {
      if (!session.empresa) return;
      var enderecoResponse = await getEndereco(
        session.empresa.replace(/E/gi, "")
      );
      if (!enderecoResponse) return;
      setDadosNota((prevDadosNota) => ({
        ...prevDadosNota,
        cidadeIncidencia: enderecoResponse?.cidade,
        ufIncidencia: enderecoResponse?.uf,
        codCidadeIncidencia: enderecoResponse?.codigoCidade,
        cidadeIncidenciaOriginal: enderecoResponse?.cidade,
        ufIncidenciaOriginal: enderecoResponse?.uf,
        codCidadeIncidenciaOriginal: enderecoResponse?.codigoCidade,
      }));
    };
    atualizarConfiguracoes();
  }, [getEndereco, session.empresa, setDadosNota]);

  //Busca estados ao renderizar tela
  React.useEffect(() => {
    const buscarEstados = async () => {
      var estadosResponse = await getEstados();
      if (!estadosResponse) return;
      setEstados(() => ({
        ...estadosResponse,
      }));
    };
    buscarEstados();
  }, [getEstados, setEstados]);

  //Busca configurações de tributação ao renderizar tela
  React.useEffect(() => {
    const buscarItensServico = async () => {
      if (!session.empresa) return;
      var configResponse = await getTributacaoConfig(
        session.empresa.replace(/E/gi, "")
      );
      if (!configResponse) return;
      setServicos(() => ({
        ...configResponse.itensServico,
      }));
      setTributacaoConfig(() => ({
        retencao: configResponse.retencao_iss === "true",
        deducoes: configResponse.retencao_federais === "true",
        retencaoInss: configResponse.retencao_inss === "true",
        recomendaRetencao: configResponse.recomenda_iss === "true",
        recomendaDeducoes: configResponse.recomenda_federais === "true",
        recomendaRetencaoInss: configResponse.recomenda_inss === "true",
        alteraMunicipio: configResponse.altera_municipio === "true",
        emissorGlobal: configResponse.emissor_global === "true",
        emissorExterior: configResponse.emissor_exterior === "true",
      }));
      setValues((prevValues) => ({
        ...prevValues,
        inssRetido:
          configResponse.retencao_inss === "true" &&
          configResponse.recomenda_inss === "true",
        deducoes:
          configResponse.retencao_federais === "true" &&
          configResponse.recomenda_federais === "true" &&
          session.tipo_empresa !== "2",
        issRetido:
          configResponse.retencao_iss === "true" &&
          configResponse.recomenda_iss === "true" &&
          session.tipo_empresa !== "2",
      }));
    };
    buscarItensServico();
  }, [
    getTributacaoConfig,
    session.empresa,
    session.tipo_empresa,
    setServicos,
    setTributacaoConfig,
  ]);

  //Busca codigos do municipio ao selecionar item de serviço
  React.useEffect(() => {
    if (values?.itemServico)
      getCodigosMunicipio(session.empresa.replace(/E/gi, ""), {
        atividade: values?.itemServico,
      });
  }, [getCodigosMunicipio, session.empresa, values?.itemServico]);

  //Define estado clientes ao receber clientes
  React.useEffect(() => {
    if (codigosMunicipioResponse)
      setAtividades(codigosMunicipioResponse["codigos_municipio"]);
  }, [codigosMunicipioResponse]);

  // Caso serviços ou atividades seja igual a 1, define-o como padrão
  React.useEffect(() => {
    if (servicos && Object.keys(servicos).length === 1)
      setValues((prevValues) => ({
        ...prevValues,
        itemServico: servicos[0].codigo,
        aliquota: servicos[0].aliquota,
      }));
    if (atividades && Object.keys(atividades).length === 1)
      setValues((prevValues) => ({
        ...prevValues,
        atividadeMunicipio: atividades[0].codigo_atividade_municipio,
      }));
  }, [atividades, servicos, values]);

  /*
   * Se o emissor for Lucro presumido ou Lucro real
   * e o tomador da nota for optante pelo Simples Nacional
   */
  React.useEffect(() => {
    setLucroSimples(
      ["3", "4"].includes(session.tipo_empresa) && values.optanteSimples
    );
  }, [session.tipo_empresa, values.optanteSimples]);

  // Calcula deduções
  React.useEffect(() => {
    var totalNota = values?.valorTotal;
    var aliquota = values?.aliquota;
    var issRetido = values?.issRetido;
    var inss;
    var iss;
    var cofins;
    var irrf;
    var pis;
    var csll;

    if (issRetido) {
      iss = (values?.valorTotal * aliquota) / 100;
    } else {
      iss = 0;
    }
    if (values.inssRetido) {
      inss = (values?.valorTotal * 11) / 100;
    } else {
      inss = 0;
    }
    if (values.deducoes && session.tipo_empresa !== "2") {
      irrf = (values?.valorTotal * 15) / 1000;
      pis = lucroSimples ? 0 : (values?.valorTotal * 65) / 10000;
      cofins = lucroSimples ? 0 : (values?.valorTotal * 3) / 100;
      csll = lucroSimples ? 0 : (values?.valorTotal * 1) / 100;
    } else {
      irrf = 0;
      pis = 0;
      cofins = 0;
      csll = 0;
    }

    const deducoes = inss + cofins + irrf + pis + csll;

    var totalLiquido = undefined;
    if (totalNota !== 0) totalLiquido = totalNota - iss - deducoes;
    setValues((prevValues) => ({
      ...prevValues,
      iss,
      inss,
      irrf,
      pis,
      cofins,
      csll,
    }));
    setDadosNota((prevData) => ({
      ...prevData,
      aliquota,
      totalNota,
      totalLiquido,
      iss,
      deducoes,
      issRetido,
    }));
  }, [lucroSimples, session.tipo_empresa, values]);

  const alertaBloqueio = React.useCallback(
    (response) => {
      setBloqueado(true);
      CommonSwal({
        icon: "warning",
        title: "Emissor de NFS-e bloqueado.",
        text: response?.error,
        allowOutsideClick: false,
        allowEscapeKey: false,
        denyButtonColor: response?.bnt_certificado
          ? Cores.buttons.verdeConfirm
          : null,
        showDenyButton: response?.bnt_certificado ? true : null,
        denyButtonText: response?.bnt_certificado
          ? "Certificado digital"
          : null,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          window.location.href = baseUrl + "dashboard";
        }
        if (result.isDenied) {
          window.location.href = baseUrl + "GestaoEmpresa/Certificado";
        }
      });
    },
    [baseUrl]
  );

  const alertaExterior = React.useCallback(() => {
    setExterior(0);
  }, []);

  //Verifica se o emissor está bloqueado
  React.useEffect(() => {
    const buscaBloqueio = async () => {
      var response;
      if (session.empresa)
        response = await getBloqueio(session.empresa.replace(/E/gi, ""));
      if (!response) return;
      if (response.emissao === 0) return alertaBloqueio(response);
      if (response.exterior === 0) alertaExterior();
    };
    buscaBloqueio();
  }, [alertaBloqueio, getBloqueio, session.empresa, alertaExterior]);

  const getDadosUltimaNota = React.useCallback(
    async (uidParam = null) => {
      const dadosNotaResponse = await getDadosNota(
        session.empresa.replace(/E/gi, ""),
        uidParam ? { uid_nota: uid } : {}
      );
      if (!dadosNotaResponse) return;
      const clienteFiltrado = clientes.find(
        (cliente) => cliente.cnpj === dadosNotaResponse?.cliente
      );
      const deducoes =
        (dadosNotaResponse?.inss > 0 && dadosNotaResponse?.inss !== "") ||
        (dadosNotaResponse?.cofins > 0 && dadosNotaResponse?.cofins !== "") ||
        (dadosNotaResponse?.irrf > 0 && dadosNotaResponse?.irrf !== "") ||
        (dadosNotaResponse?.pis > 0 && dadosNotaResponse?.pis !== "") ||
        (dadosNotaResponse?.csll > 0 && dadosNotaResponse?.csll !== "");

      setValues(() => ({
        ...dadosNotaResponse,
        descricaoServicoPrestado: dadosNotaResponse?.descricao,
        itemServico: dadosNotaResponse?.itemListaServicoLC116,
        atividadeMunicipio: dadosNotaResponse?.codigoServicoMunicipio,
        issRetido: dadosNotaResponse?.issRetidoFonte,
        aliquota: dadosNotaResponse?.aliquotaIss,
        cliente: clienteFiltrado?.uid,
        deducoes: deducoes,
      }));
      setDadosNota((prevValues) => ({
        ...prevValues,
        issRetido: dadosNotaResponse?.issRetidoFonte,
      }));
      console.log("teste");
    },
    [clientes, getDadosNota, session.empresa, uid]
  );

  //Busca dados da nota caso seja passado o parâmetro
  React.useEffect(() => {
    if (uid && session?.empresa && clientes.length > 0 && stop === 0) {
      getDadosUltimaNota(uid);
      setStop(1);
    }
  }, [getDadosUltimaNota, session?.empresa, uid, clientes, stop]);

  //Ao trocar cliente pode desativar algumas retenções
  React.useEffect(() => {
    if (dadosNota?.cnpj && dadosNota?.cnpj.length === 11)
      setValues((prevValues) => ({
        ...prevValues,
        issRetido: false,
        inssRetido: false,
        deducoes: false,
      }));
  }, [dadosNota?.cnpj]);

  const togAlterarMunicipioModal = React.useCallback(() => {
    setAlterarMunicipioValues({
      estado: "",
      estadoId: "",
      estadoSigla: "",
      municipio: "",
      municipioId: "",
    });
    setAlterarMunicipioModal(true);
  }, []);

  const alterarMunicipio = () => {
    if (!alterarMunicipioValues.estado || !alterarMunicipioValues.municipio)
      return CommonSwal({
        icon: "warning",
        title: "Município de incidência",
        text: "Não foi possivel pegar as informações solicitadas, tente novamente",
      });

    setDadosNota((prevData) => ({
      ...prevData,
      ufIncidencia: alterarMunicipioValues.estadoSigla,
      cidadeIncidencia: alterarMunicipioValues.municipio,
      codCidadeIncidencia: alterarMunicipioValues.municipioId,
    }));
    setAlterarMunicipioModal(false);
  };

  const definirTomadorGlobal = () => {
    setValues(() => ({
      ...values,
      issRetido: false,
      inssRetido: false,
      deducoes: false,
      cliente: "GLOBAL",
    }));
    setDadosNota((prevValues) => ({
      ...prevValues,
      issRetido: false,
    }));

    const existeClienteGlobal = clientes.some(
      (cliente) => cliente.uid === "GLOBAL"
    );

    if (!existeClienteGlobal) {
      const clienteGlobal = {
        razao_social: "Clientes diversos",
        cnpj: null,
        uid: "GLOBAL",
        email: "",
      };
      setClientes([...clientes, clienteGlobal]);
    }

    setDadosNota((prevData) => ({
      ...prevData,
      cidadeIncidencia: dadosNota.cidadeIncidenciaOriginal,
      ufIncidencia: dadosNota.ufIncidenciaOriginal,
      codCidadeIncidencia: dadosNota.codCidadeIncidenciaOriginal,
      razao_social: "Clientes diversos",
      codigoCidade: "999999",
      tipoTomador: "Clientes diversos",
      uid: "GLOBAL",
      cnpj: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      cep: "",
      uf: "",
    }));
  };

  const checkClientesTab = () => {
    if (!dadosNota.razao_social) {
      ErrorSwal({
        title:
          "É necessário selecionar um cliente para ir para a próxima etapa.",
      });
      return false;
    }
    if (dadosNota?.cnpj === "99999999999" && exterior === 0) {
      ErrorSwal({
        text: "A emissão de NFS-e para o exterior não está liberada para esta empresa. Por favor, entre em contato com o suporte para ativar esta funcionalidade.",
      });
      return false;
    }
    return true;
  };

  const checkServicoTab = () => {
    if (dadosNota.descricaoServicoPrestado.length < 5) {
      ErrorSwal({
        title: "Descrição deve possuir mais de 5 caracteres.",
      });
      return false;
    } else if (!dadosNota.totalNota || dadosNota.totalNota < 1) {
      ErrorSwal({
        title: "Valor do serviço deve ser superior a R$1,00.",
      });
      return false;
    }
    return true;
  };

  const emitirNota = () => {
    if (bloqueado) return;
    OptionsSwal({
      title: "Estamos prontos para enviar a NFS-e. Todos os dados estão OK?",
      icon: "question",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("descricao", dadosNota?.descricaoServicoPrestado);
        formData.append("valor", dadosNota?.totalNota);
        formData.append(
          "aliquota",
          dadosNota?.cnpj !== "99999999999" ? dadosNota?.aliquota : 0
        );
        formData.append("item_lista_servico_LC116", dadosNota?.itemServico);
        formData.append("tomador", dadosNota?.uid);
        formData.append("emissor", session?.user_guid);

        if (Object.keys(atividades).length > 0) {
          formData.append(
            "codigo_servico_municipio",
            dadosNota?.atividadeMunicipio
          );
        }

        if (Validation.verificarForm(formData))
          return {
            text: "Favor preencher todos os dados obrigatórios.",
          };

        formData.append("inss", values?.inss || 0);
        formData.append("cofins", values?.cofins || 0);
        formData.append("irrf", values?.irrf || 0);
        formData.append("pis", values?.pis || 0);
        formData.append("csll", values?.csll || 0);
        formData.append(
          "municipio_inicidencia",
          dadosNota?.codCidadeIncidencia
        );
        formData.append("uf_inicidencia", dadosNota?.ufIncidencia);
        formData.append("iss_retido_fonte", dadosNota?.issRetido ? 1 : 0);

        if (Object.keys(atividades).length === 0) {
          formData.append(
            "codigo_servico_municipio",
            dadosNota?.atividadeMunicipio
          );
        }

        const response = await emitirNotaFiscal(
          session.empresa.replace(/E/gi, ""),
          formData
        );
        if (!response) return;
        CommonSwal({
          title: "NFS-e enviada",
          text: 'Verifique no menu "Notas Fiscais" na área de "Gerenciador de notas" o status da sua emissão',
          icon: "success",
        }).then(async () => {
          if (result.isConfirmed || result.isDismissed) {
            OptionsSwal({
              title: "Nota emitida",
              icon: "question",
              text: 'Deseja emitir uma nova nota ou  ir para o "Gerenciador de notas"?',
              confirmButtonText: "Nova nota",
              denyButtonText: "Gerenciar notas",
              confirmButtonColor: Cores.common.primary,
              denyButtonColor: Cores.buttons.verdeConfirm,
              reverseButtons: true,
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              } else if (result.isDenied) {
                window.location.href =
                  baseUrl + "contabilidade/notaFiscal/NotaFiscal";
              }
            });
          }
        });
      }
    });
  };

  const togNovoClienteModal = React.useCallback(() => {
    setClienteValues({});
    setClienteTab(0);
    setNovoClienteModal(true);
    setSent(false);
  }, []);

  const resetaClientes = () => {
    setValues((prevValues) => ({ ...prevValues, cliente: "" }));
    setDadosNota((prevValues) => ({
      ...prevValues,
      razao_social: "",
      cnpj: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      cidade: "",
      cep: "",
      uf: "",
      codigoCidade: "",
    }));
    setClientes([]);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-7">
          <Card margin={0}>
            <TabList>
              <TabButton href="clienteTab" ativo={true} disabled={true}>
                Cliente
              </TabButton>
              <TabButton href="servicoTab" disabled={true}>
                Serviço
              </TabButton>
              <TabButton href="tributacaoTab" disabled={true}>
                Tributação
              </TabButton>
            </TabList>
            <TabContent padding={0}>
              <ClienteTab
                clientesHook={{ clientes, setClientes }}
                tabAtualHook={{ tabAtual, setTabAtual }}
                valuesHook={{ values, setValues }}
                definirTomadorGlobal={definirTomadorGlobal}
                checkClientesTab={checkClientesTab}
                getDadosUltimaNota={getDadosUltimaNota}
                togNovoClienteModal={togNovoClienteModal}
                tributacaoConfig={tributacaoConfig}
              />
              <ServicoTab
                checkServicoTab={checkServicoTab}
                tabAtualHook={{ tabAtual, setTabAtual }}
                valuesHook={{ values, setValues }}
              />
              <TributacaoTab
                tabAtualHook={{ tabAtual, setTabAtual }}
                valuesHook={{ values, setValues }}
                servicos={servicos}
                atividades={atividades}
                tributacaoConfig={tributacaoConfig}
                modalTog={togAlterarMunicipioModal}
                dadosNota={dadosNota}
                emitirNota={emitirNota}
                lucroSimples={lucroSimples}
              />
            </TabContent>
          </Card>
        </div>
        <div className="col-md-5">
          <Card margin={0}>
            <DadosNFSe
              dadosNota={dadosNota}
              atividades={atividades}
              valuesHook={{ values, setValues }}
            />
          </Card>
        </div>
      </div>
      <AlterarMunicipioModal
        modalHook={{ alterarMunicipioModal, setAlterarMunicipioModal }}
        modalValues={{ alterarMunicipioValues, setAlterarMunicipioValues }}
        alterarMunicipio={alterarMunicipio}
        estados={estados}
        municipios={municipios}
      />
      <NovoClienteModal
        modalHook={{ novoClienteModal, setNovoClienteModal }}
        valuesHook={{ clienteValues, setClienteValues }}
        clienteTabHook={{ clienteTab, setClienteTab }}
        buscaClientes={getClientes}
        resetaClientes={resetaClientes}
        sentHook={{ sent, setSent }}
      />
    </>
  );
}

export default EmissorNFSe;
